export function setValueToNestedObject(path, value, source, level = 0) {
  if (Array.isArray(source)) {
    return;
  }
  var valueToChange = source;
  for (let index = 0; index < path.length - 1; index++) {
    valueToChange = valueToChange[path[index]];
  }

  const endPath = path[path.length - 1];
  if (valueToChange && valueToChange[endPath] != undefined) {
    valueToChange[endPath] = value;
  }

  /*   for (let index = 0; index < path.length; index++) {
    if (source.hasOwnProperty(path[index])) {
      if (path[index] === path[path.length - 1] && level === path.length - 1) {
        source[path[index]] = value;
      } else {
        level++;
        source[path[index]] = setValueToNestedObject(
          path,
          value,
          source[path[index]],
          level
        );
      }
    }
  } */
  return source;
}
export function getValueFromNestedObject(path, source, value, level = 0) {
  if (Array.isArray(source)) {
    return;
  }
  var valueToGet = source;
  for (let index = 0; index < path.length - 1; index++) {
    valueToGet = valueToGet[path[index]];
  }
  if (valueToGet && valueToGet[path[path.length - 1]]) {
    return valueToGet[path[path.length - 1]];
  }
  return "";
}
/* export function deepClone(source) {
  if (Array.isArray(source)) {
    return Array.from(source);
  }

  let target = Object.assign({}, source);
  for (const key in source) {
    if (
      source.hasOwnProperty(key) &&
      source[key] &&
      typeof source[key] === "object" &&
      source[key] !== RegExp &&
      !(source[key] instanceof Date) &&
      !(source[key] instanceof Error) &&
      key !== 'editor'
    ) {
      target[key] = deepClone(source[key]);
    }
  }
  return target;
} */
export function getValueFromNestedObjectByParam(
  params,
  source,
  array,
  level = 0
) {
  if (Array.isArray(source)) {
    return;
  }
  for (const key in source) {
    if (isObject(source, key) && !Array.isArray(source[key])) {
      if (params.includes(key)) {
        array.push(source[key]);
      } else {
        getValueFromNestedObjectByParam(params, source[key], array, level);
      }
    } else {
      if (params.includes(key)) {
        array.push(source[key]);
      }
    }
  }
  return array;
}

export function checkForUpdatesOneLevel(target, source) {
  const sourceObj = Object.assign({}, source);
  let targetObj = Object.assign({}, target);

  //* Loops two levels of an object*/

  for (const prop in sourceObj) {
    if (!targetObj.hasOwnProperty(`${prop}`)) {
      if (sourceObj[prop] !== typeof "object") {
        targetObj[prop] = sourceObj[prop];
      }

      if (targetObj.hasOwnProperty(`${prop}`)) {
      }
    }
  }
  return targetObj;
}

/* 
export function checkForUpdates(target, source) {
    const sourceObj = Object.assign({}, source);
    let targetObj = Object.assign({}, target)


    for (const prop in sourceObj) {
        if (!targetObj.hasOwnProperty(`${prop}`)) {
            targetObj[prop] = { ...sourceObj[prop] };
            if (targetObj.hasOwnProperty(`${prop}`)) {
            }
        }
        else {
            for (const v in sourceObj[prop]) {

                if (!targetObj[prop].hasOwnProperty(v)) {
                    targetObj[prop][v] = sourceObj[prop][v];
                    for (const k in sourceObj[prop][v]) {
                        targetObj[prop][v][k] = sourceObj[prop][v][k];
                    }
                 
                }
            }
        }
    }
    for (const prop in targetObj) {
        if (!sourceObj.hasOwnProperty(`${prop}`)) {
            targetObj[prop] = undefined;

        }
        else {
            for (const v in sourceObj[prop]) {

                if (!sourceObj[prop].hasOwnProperty(v)) {
                    targetObj[prop][v] = undefined;
                }
            }
        }
    }
    return targetObj;
} */

function isObject(source, key) {
  return (
    source.hasOwnProperty(key) &&
    typeof source[key] === "object" &&
    source[key] !== RegExp &&
    !(source[key] instanceof Date) &&
    !(source[key] instanceof Error)
  );
}

export function checkForFormUpdates(target, source) {
  if (Array.isArray(source)) {
    return Array.from(target);
  }
  const targetObj = Object.assign({}, target);
  for (const key in source) {
    if (isObject(source, key)) {
      if (!targetObj.hasOwnProperty(key)) {
        targetObj[key] = deepClone(source[key]);
      } else {
        targetObj[key] = checkForFormUpdates(targetObj[key], source[key]);
      }
    } else {
      if (!targetObj.hasOwnProperty(key)) {
        targetObj[key] = source[key];
      }
    }
  }
  return targetObj;
}

export function checkForTemplateUpdates(target, source) {
  if (Array.isArray(source)) {
    /*        if(target.length < 1) return Array.from(source);
        else return Array.from(target); */
    return;
  }
  const targetObj = Object.assign({}, target);
  for (const key in source) {
    if (isObject(source, key) && !Array.isArray(source[key])) {
      if (!targetObj.hasOwnProperty(key)) {
        targetObj[key] = deepClone(source[key]);
      } else {
        targetObj[key] = checkForTemplateUpdates(targetObj[key], source[key]);
      }
    } else {
      if (!targetObj.hasOwnProperty(key)) {
        targetObj[key] = "unset";
      }
    }
  }
  return targetObj;
}
export function deepClone(source) {
  if (Array.isArray(source)) {
    return Array.from(source);
  }

  let target = Object.assign({}, source);
  for (const key in source) {
    if (
      source.hasOwnProperty(key) &&
      source[key] &&
      typeof source[key] === "object" &&
      source[key] !== RegExp &&
      !(source[key] instanceof Date) &&
      !(source[key] instanceof Error) &&
      key !== "editor"
    ) {
      target[key] = deepClone(source[key]);
    }
  }
  return target;
}

export function toCamelCase(input) {
  return input[0].toLowerCase() + input.substr(1, input.length);
}

export const combineProps = (objArr) => {
  let spreadedObj = {};
  objArr.map((o) => {
    spreadedObj = { ...spreadedObj, ...o };
  });
  return spreadedObj;
};
